import "rxjs/add/operator/map";
var TranslateHttpLoader = (function () {
    function TranslateHttpLoader(http, prefix, suffix) {
        if (prefix === void 0) { prefix = "/assets/i18n/"; }
        if (suffix === void 0) { suffix = ".json"; }
        this.http = http;
        this.prefix = prefix;
        this.suffix = suffix;
    }
    /**
     * Gets the translations from the server
     * @param lang
     * @returns {any}
     */
    TranslateHttpLoader.prototype.getTranslation = function (lang) {
        return this.http.get("" + this.prefix + lang + this.suffix)
            .map(function (res) { return res.json(); });
    };
    return TranslateHttpLoader;
}());
export { TranslateHttpLoader };



//////////////////
// WEBPACK FOOTER
// /www/sms-simulator/sms-front/~/@ngx-translate/http-loader/src/http-loader.js
// module id = ../../../../@ngx-translate/http-loader/src/http-loader.js
// module chunks = 3